const messagesPt = {
  about: 'Sobre',
  acceptanceCriteria: 'Critérios de Aceitação',
  accomplishments: 'Realizações',
  actions: 'Ações',
  activity: 'Atividade',
  activatePod: 'Ativar POD',
  activePods: 'PODs Ativos',
  add: 'Adicionar',
  addBlocker: 'Adicionar Informação de Bloqueio',
  addingCandidateWait: 'Adicionando candidato, aguarde...',
  addPortfolio: 'Adicionar Portfólio',
  addStakeholder: 'Adicionar Parte Interessada',
  addVideoUpdate: 'Adicionar Atualização de Vídeo',
  findAgents: 'Encontrar Agentes',
  all: 'Todos',
  allReporters: 'Todos os Relatores',
  allRepoCheckins: 'Todos os Check-ins do Repositório',
  approve: 'Aprovar',
  approved: 'Aprovado',
  approvalRequests: 'Solicitações de Aprovação',
  approvedPRCount: 'Contagem de PR Aprovados',
  assignedItems: 'Itens Atribuídos',
  availability: 'Disponibilidade',
  availableDate: 'Data disponível',
  backToPods: 'Voltar aos Meus PODs',
  basicInformation: 'Informações Básicas',
  blocker: 'Bloqueio',
  blockerDetails: 'Detalhes do Bloqueio',
  blockers: 'Bloqueios',
  board: 'Quadro',
  browseTalent: 'Navegar Talentos',
  bugs: 'Bugs',
  calendlyUrl: 'URL do Calendly',
  cancel: 'Cancelar',
  candidates: 'Candidatos',
  categories: 'Categorias',
  certifications: 'Certificações',
  certificationUrl: 'URL da Certificação',
  checkBoxBlocker: 'Marque esta caixa se for um bloqueio',
  ciCdPipeline: 'Pipeline CI/CD',
  clear: 'Limpar',
  client: 'Cliente',
  clickHereUploadVideoClip: 'Clique aqui para enviar um clipe de vídeo!',
  cloudCost: 'Custo da Nuvem',
  code: 'Linhas de Código',
  codeSmells: 'Code Smells',
  commentHere: 'comente aqui...',
  category: 'Categoria',
  comments: 'Comentários',
  companyName: 'Nome da Empresa',
  copied: 'Copiado!',
  copyright: 'Copyright © 2025-presente Brilli Global, Inc. Todos os direitos reservados.',
  copyToClipboard: 'Copiar para área de transferência',
  cost: 'Custo',
  costDetails: 'Detalhes do Custo',
  country: 'País',
  create: 'Criar',
  createArt: 'Criar ART',
  createGig: 'Criar Solução',
  createPod: 'Criar POD',
  createProfile: 'Criar Perfil',
  createProfileOpportunity: 'Crie seu perfil em nosso banco de dados de talentos para ser incluído em várias oportunidades de trabalho remoto.',
  createTask: 'Criar Tarefa',
  createYourOwnPod: 'Crie seu próprio POD e navegue por projetos',
  creatingProfile: 'Criando perfil',
  currency: 'Moeda',
  currentlyAvailable: 'Atualmente Disponível',
  currentWeek: 'Semana Atual',
  dashboard: 'Painel',
  date: 'Data',
  dateRangeFilter: 'Filtro de Intervalo de Data',
  deactivatePod: 'Desativar POD',
  deactivateToUpdate: 'Desative o POD para atualizar o POD!',
  defects: 'Defeitos',
  delete: 'Excluir',
  deletePod: 'Excluir POD',
  description: 'Descrição',
  detailsForGitHubRepo: 'Detalhes do Repositório GitHub',
  done: 'fechar',
  Done: 'CONCLUÍDO',
  doraMetrics: 'Métricas Dora',
  dueDate: 'Data de Vencimento',
  duplicatedLinesDensity: 'Densidade de Linhas Duplicadas',
  edit: 'Editar',
  education: 'Educação',
  educationAndCertifications: 'Educação e Certificações',
  email: 'E-mail',
  podTime: 'Tempo POD',
  createHub: 'Criar Hub',
  createSolution: 'Criar Solução',
  podVelocity: 'Velocidade POD',
  podBlockers: 'Bloqueios POD',
  podsync: 'Sincronização POD',
  endDate: 'Data de término',
  enterEmailToInvite: 'Digite um e-mail para convidar',
  enterPodMission: 'Digite a Missão do POD',
  enterPodName: 'Digite o Nome do POD',
  enterStoryDescription: 'Digite uma Descrição da História',
  executionDate: 'Data de Execução',
  executionID: 'ID de Execução',
  externalPod: 'POD Externo',
  fileNameNoSpaces: 'O nome do arquivo não deve incluir espaços entre todos os elementos ou caracteres',
  fileUpload: 'Upload de Arquivo',
  findBestFreelancers: 'Encontre os melhores freelancers ou PODs de talentos para ter seus projetos entregues em um ritmo mais rápido!',
  findBestPod: 'Encontre PODs que correspondam à sua experiência/conjunto de habilidades',
  findPods: 'Encontrar PODs',
  findTalent: 'Encontrar Talentos',
  findYourBestTalentPod: 'Encontre seu melhor POD de talentos',
  firstName: 'Primeiro Nome',
  focus: 'Foco',
  gitHubRepo: 'Repositório GitHub',
  gitHubUsername: 'Nome de Usuário GitHub',
  github: 'Github',
  githubSummary: 'Resumo GitHub',
  githubUrl: 'URL do Github',
  githubUser: 'Usuário GitHub',
  giveRating: 'Dar Avaliação',
  globalWorkPlatform: 'Plataforma de Trabalho Global',
  home: 'Início',
  hoursPerWeek: 'Horas por Semana',
  inactivePod: 'POD Inativo',
  individual: 'Individual',
  industry: 'Indústria',
  inProgress: 'EM PROGRESSO',
  institute: 'Instituto',
  internalPod: 'POD Interno',
  invite: 'Convidar',
  invoices: 'Faturas',
  issueKey: 'Chave da Issue',
  issueStatus: 'Status da Issue',
  issueSummary: 'Resumo da Issue',
  jiraIssue: 'Issue Jira',
  jiraIssues: 'Issues Jira',
  jiraItem: 'Item Jira',
  jiraTimeDetails: 'Registro de Tempo',
  jiraUsername: 'Nome de Usuário Jira',
  keepDoing: 'Continue Fazendo',
  keyword: 'Palavra-chave',
  languageSpoken: 'Idioma Falado',
  lastName: 'Sobrenome',
  latestSprintVelocity: 'Velocidade do Sprint Mais Recente',
  linkedIn: 'LinkedIn',
  linkedInUrl: 'URL do LinkedIn',
  linesOfCodeByDay: 'Linhas de Código por Dia',
  listOfTalents: 'Lista de Talentos',
  loading: 'Carregando',
  loadingAcceptanceCriteria: 'Carregando Critérios de Aceitação',
  loadingStoryDescription: 'Carregando Descrição da História',
  loadingTestCases: 'Carregando Casos de Teste',
  logOut: 'Sair',
  login: 'Entrar',
  manage: 'Gerenciar',
  manageActivities: 'Gerencie suas atividades diárias do POD e atualizações',
  manageProfile: 'Gerenciar perfil',
  manageProfileHere: 'Gerencie seu perfil aqui',
  managePod: 'Gerenciar POD',
  managePods: 'Gerencie todos os seus PODs e suas atividades',
  markComplete: 'Marcar como Concluído',
  middleName: 'Nome do Meio',
  myPods: 'Meus PODs',
  myTasks: 'Minhas Tarefas',
  name: 'Nome',
  ncloc: 'Ncloc',
  newActivityUpdate: 'Nova Atualização de Atividade',
  next: 'Próximo',
  noArtOptionsAvailable: 'Nenhuma Opção ART Disponível',
  noBlockers: 'Não Há Bloqueios',
  noCandidates: 'Nenhum Candidato foi Adicionado',
  noCandidatesAddedToPod: 'Nenhum Candidato Adicionado ao POD!',
  noCandidateReviews: 'Não há avaliações de candidatos.',
  noData: 'Sem Dados',
  noDataAvailable: 'Nenhum dado disponível',
  noExperience: 'Sem Experiência',
  noMatchingPods: 'Não há PODs correspondentes disponíveis',
  noNotifications: 'Não há notificações',
  noPodActivity: 'Você Não Tem Nenhuma Atividade de POD',
  noPods: 'Você Não tem nenhum POD',
  noPodTasks: 'Você não tem nenhuma Tarefa de POD',
  noReviews: 'Não há avaliações.',
  noStakeholders: 'Não Há partes interessadas para este POD',
  noSubscription: 'Você não tem nenhum plano de assinatura',
  noVideoAvailable: 'Nenhum vídeo disponível',
  notifications: 'Destinatário de Notificação',
  otherInformation: 'Outras Informações',
  pending: 'Pendente',
  pendingPods: 'PODs Pendentes',
  phoneNumber: 'Número de Telefone',
  pipelineExecutionDetails: 'Detalhes de Execução do Pipeline',
  pipelineName: 'Nome do Pipeline',
  pipelineVersion: 'Versão do Pipeline',
  pleaseEnterStoryDescription: 'Por favor, digite uma descrição da história e clique em enviar',
  POD: 'POD',
  podActivities: 'Atividades do POD',
  podActivity: 'Atividade do POD',
  podAnalytics: 'Análises do POD',
  podAssist: 'Assistente POD',
  podAutomation: 'Automação POD',
  podBoard: 'Quadro POD',
  podCategories: 'Categorias POD',
  podDescription: 'Descrição do POD',
  podExperience: 'Experiência do POD',
  podFeedback: 'Feedback do POD',
  podMetrics: 'Métricas do POD',
  podName: 'Nome do POD',
  podQuery: 'Consulta POD',
  podRequests: 'SOLICITAÇÕES POD',
  podRetro: 'Retrospectiva POD',
  podSize: 'Tamanho do POD',
  podTasks: 'Tarefas do POD',
  podTaskDescription: 'Descrição da Tarefa POD',
  podTaskDueDate: 'Data de Vencimento da Tarefa POD',
  podTaskName: 'Nome da Tarefa POD',
  podTaskOwner: 'Proprietário da Tarefa POD',
  podTaskStatus: 'Status da Tarefa POD',
  podTechStack: 'Stack Tecnológico POD',
  podTeamMember: 'Membro da Equipe POD',
  podType: 'Tipo de POD',
  portfolio: 'Portfólio',
  portfolioUrl: 'URL do Portfólio',
  post: 'Publicar',
  postActivity: 'Publicar Atividade',
  postPodActivity: 'Publicar Atividade POD',
  postRequirement: 'Publicar Requisito',
  posting: 'Publicando...',
  postedDate: 'Data de Publicação',
  postedRequirements: 'Seus Requisitos POD Publicados',
  positionName: 'Nome da Posição',
  prCount: 'Contagem PR',
  preferredWorkHours: 'Horário de Trabalho Preferido',
  prev: 'Anterior',
  previousPods: 'PODs Anteriores',
  previousWeek: 'Semana Anterior',
  primarySkill: 'Habilidade Primária',
  privacyPolicy: 'Política de Privacidade',
  privatePods: 'PODs Privados',
  prSummary: 'Resumo PR',
  projectKey: 'Chave do Projeto',
  profileLink: 'Link do Perfil',
  profileVisibility: 'Visibilidade do Perfil',
  public: 'Público',
  qualification: 'Qualificação',
  ratePerHour: 'Taxa por Hora',
  ratePerMonth: 'Taxa por Mês',
  recentSearches: 'Pesquisas Recentes',
  region: 'Região',
  register: 'Registrar',
  resetPassword: 'Redefinir Senha',
  restricted: 'Restrito',
  retro: 'Retrospectiva',
  review: 'Avaliação e Classificação',
  revisionSummary: 'Resumo da Revisão',
  revisionURL: 'URL da Revisão',
  resume: 'Currículo',
  resumeLink: 'Ver Currículo',
  rowsPerPage: 'Linhas por página',
  save: 'Salvar',
  search: 'Pesquisar',
  searchProjects: 'Pesquisar projetos',
  secondarySkill: 'Habilidade Secundária',
  select: 'Selecionar',
  selectArtName: 'Selecionar Nome ART',
  selectAUser: 'Selecionar um Usuário',
  selectFilter: 'Selecionar Filtro',
  applyFilters: 'Aplicar Filtros',
  selectItemsPerPage: 'Selecionar itens por página',
  selectJiraIssues: 'Selecionar Issues Jira',
  selectPod: 'Selecionar um POD',
  selectPodTeamMember: 'Selecionar Membro da Equipe POD',
  selectPods: 'Selecionar PODs',
  services: 'Serviços',
  setting: 'Configuração',
  shareableLink: 'Link Compartilhável',
  signUpToGetStarted: '"Cadastre-se" abaixo para começar!',
  getStarted: 'Começar',
  skills: 'Habilidades',
  skillsAndExpertise: 'Habilidades e Expertise',
  sonarqubeprojectkey: 'Chave do Projeto Sonarqube',
  sonarqubeStats: 'Estatísticas Sonarqube',
  specialization: 'Especialização',
  sprintVelocity: 'Velocidade do Sprint',
  sprint: 'Sprint',
  spotsLeft: 'Vagas Restantes',
  startDate: 'Data de início',
  startDoing: 'Começar a Fazer',
  status: 'Status',
  stopDoing: 'Parar de Fazer',
  storyDescription: 'Descrição da História',
  stories: 'Histórias',
  submit: 'Enviar',
  submittedDate: 'Data de Envio',
  submittedPRCount: 'Contagem de PR Enviados',
  subscription: 'Assinatura',
  talentApprovalRequests: 'Solicitações de Aprovação de Talentos',
  talentCode: 'Código do Talento',
  taskForm: 'Formulário de Tarefa',
  taskManager: 'Gerenciador de Tarefas',
  taskName: 'Nome da Tarefa',
  tasks: 'Tarefas',
  teamMember: 'Membro da Equipe',
  techStack: 'Stack Tecnológico',
  termsOfService: 'Termos de Serviço',
  testCases: 'Casos de Teste',
  time: 'Tempo',
  timeLog: 'Registro de Tempo',
  timeSubmit: 'Envio de Tempo',
  timeZone: 'Fuso Horário',
  toDo: 'A FAZER',
  todaysFocus: 'Foco de Hoje',
  totalLinesChangedLastWeek: 'Total de Linhas Alteradas na Semana Passada',
  totalLinesChangedThisWeek: 'Total de Linhas Alteradas Esta Semana',
  totalPRCount: 'Contagem Total de PR',
  university: 'Universidade',
  update: 'Atualizar',
  updateProfileHere: 'Atualize seu perfil aqui',
  updatingVisibility: 'Atualizando visibilidade...',
  upload: 'Upload',
  userStory: 'História do Usuário',
  validFrom: 'Válido de',
  validTill: 'Válido até',
  talentexplorer: 'Explorador de Talentos',
  interviewrequests: 'Solicitações de Entrevista',
  videoUrl: 'URL do Vídeo',
  view: 'Ver',
  viewActivities: 'Ver Atividades',
  viewDetails: 'Ver Detalhes',
  viewPodActivities: 'Ver Atividades POD',
  viewPodDetails: 'Ver Detalhes POD',
  viewProfile: 'Ver Perfil',
  viewTasks: 'Ver Tarefas',
  viewTimeEntries: 'Ver Entradas de Tempo',
  viewVideo: 'Ver Vídeo',
  visitFindTalent: 'Por favor, visite a página "Encontrar Talentos" e adicione indivíduos talentosos ao seu POD.',
  vulnerabilities: 'Vulnerabilidades',
  welcome: 'Bem-vindo ao Artemy.ai!',
  workExperience: 'Experiência Profissional',
  yourPod: 'Seu POD',
  yourPods: 'Seus PODs',
  yourPostedPodActivity: 'Sua Atividade POD Publicada',
  
  findTickets: 'Encontrar Tickets',
  epics: 'Épicos',
  date: 'Data',
  talent: 'Talento',
  focus: 'Foco',
  startDate: 'Data de Início',
  endDate: 'Data de Término',
  status: 'Status',
  allStatus: 'Todos os Status',
  blocked: 'Bloqueado',
  onTrack: 'No Caminho Certo',
  activityDetails: 'Detalhes da Atividade',
  jiraIssues: 'Issues Jira',
  todaysFocus: 'Foco de Hoje',
  accomplishments: 'Realizações',
  blockers: 'Bloqueios',
  videoUpdate: 'Atualização de Vídeo',
  comments: 'Comentários',
  addBlockerInformation: 'Adicionar Informação de Bloqueio',
  blockerDetails: 'Detalhes do Bloqueio',
  cancel: 'Cancelar',
  saveChanges: 'Salvar Alterações',
  selectJiraIssues: 'Selecionar Issues Jira',
  design: 'Design',
  development: 'Desenvolvimento',
  testing: 'Teste',
  bugFix: 'Correção de Bug',
  documentation: 'Documentação',
  myPods: 'Meus PODs',
  postRetro: 'Publicar Retrospectiva',
  newRetro: 'Nova Retrospectiva',
  startDoing: 'Começar a Fazer',
  stopDoing: 'Parar de Fazer',
  keepDoing: 'Continue Fazendo',
  viewRetros: 'Ver Retrospectivas',
  podRetroFeedback: 'Feedback da Retrospectiva POD',
  selectSprint: 'Selecionar Sprint',
  thisTaskIsBlocker: 'Esta tarefa é um bloqueio',
  category: 'Categoria',
  taskCreatedSuccessfully: 'Tarefa criada com sucesso!',
  taskManagement: 'Gerenciamento de Tarefas',
  searchJiraIssues: 'Pesquisar issues JIRA...',
  creatingTask: 'Criando Tarefa...',
  createTask: 'Criar Tarefa',
  description: 'Descrição',
  dueDate: 'Data de vencimento',
  commentsHistory: 'Histórico de Comentários',
  noCommentsYet: 'Nenhum comentário ainda',
  writeAComment: 'Escreva um comentário...',
  all: 'Todos',
  blockerStatus: 'Status do Bloqueio',
  blockedTasks: 'Tarefas Bloqueadas',
  unblockedTasks: 'Tarefas Desbloqueadas',
  clearDateRange: 'Limpar Intervalo de Data',
  selectDateRange: 'Selecionar Intervalo de Data',
  showAllTime: 'Mostrar Todo o Tempo',
  noTasksFound: 'Nenhuma tarefa encontrada',
  noLinkedIssues: 'Nenhuma issue vinculada',
  timeSheet: 'Planilha de Tempo',
  podTimeSheet: 'Planilha de Tempo POD',
  userStory: 'História do Usuário',
  hours: 'Horas',
  minutes: 'Minutos',
  actions: 'Ações',
  submitTimeEntries: 'Enviar Entradas de Tempo',
  selectCategory: 'Selecionar Categoria',
  selectStory: 'Selecionar História',
  addRow: 'Adicionar Linha',
  podSelection: 'Seleção de POD',
  selectPodToView: 'Selecione um POD para ver filtros de sprint e talento',
  toDo: 'A Fazer',
  podAssist: 'Assistente POD',
  inProgress: 'Em Progresso',
  done: 'Concluído',
  selectPodsRequired: 'Selecionar PODs (Obrigatório)',
  enterStoryDescription: 'Digite uma Descrição da História',
  podSyncSummaries: 'Resumos de Sincronização POD',
  enterMeetingUrl: 'Digite a URL da reunião...',
  searchInSummaries: 'Pesquisar nos resumos...',
  dateAndTime: 'Data e Hora',
  quickTimeRange: 'Intervalo de Tempo Rápido',
  sortByDate: 'Ordenar por Data',
  selectTalents: 'Selecionar Talentos',
  filterBySpecificCandidates: 'Filtrar por candidatos específicos (opcional)',
  talentSelection: 'Seleção de Talentos',
  priority: 'Prioridade',
  addComment: 'Adicionar Comentário',
  taskDetails: 'Detalhes da Tarefa',
  summary: 'Resumo',
  addMeeting: 'Adicionar Reunião',

  podAutomation: 'Automação POD',
  uploading: 'Enviando...',
  uploadFile: 'Enviar Arquivo',
  send: 'Enviar',
  submitting: 'Enviando...',
  enterYourQuestionHere: 'Digite sua pergunta aqui',
  submitTheResults: 'Enviar os resultados',
  export: 'Exportar',
  podInsights: 'Insights POD',
  askQuestionsAboutYourPod: 'Faça perguntas sobre suas atividades POD, membros da equipe e mais',
  welcomeToPodInsights: 'Bem-vindo aos Insights POD!',
  startByAskingQuestionsLike: 'Comece fazendo perguntas como',
  showAllPodActivitiesThatHadBlockers: 'Mostrar todas as atividades POD que tiveram bloqueios',
  listAllCandidatesAndTheirPods: 'Listar todos os candidatos e seus PODs',
  showStakeholdersFromIndia: 'Mostrar partes interessadas da Índia',
  askAnythingAboutYourPods: 'Pergunte qualquer coisa sobre seus PODs, membros da equipe, atividades...',
  sending: 'Enviando...',
  analyzingYourQuestion: 'Analisando sua pergunta...',
  pipelineCICD: 'Pipeline CI/CD',
  tickets: 'Tickets',
  metricName: 'Nome da Métrica',
  metricValue: 'Valor da Métrica',
  commentsHistory: 'Histórico de Comentários',
  noCommentsYet: 'Nenhum comentário ainda',
  writeAComment: 'Escreva um comentário...',
  solutionManagement: 'Gerenciamento de Soluções',
  searchSolutions: 'Pesquisar Soluções...',
  refresh: 'Atualizar',
  createNewSolution: 'Criar Nova Solução',
  solutionName: 'Nome da Solução',
  solutionDescription: 'Descrição da Solução',
  updateSolution: 'Atualizar Solução',
  createSolution: 'Criar Solução',
  confirmSolutionDeletion: 'Tem certeza de que deseja excluir a Solução',
  artManagement: 'Gerenciamento ART',
  podManagement: 'Gerenciamento POD',
  searchPods: 'Pesquisar PODs...',
  viewPod: 'Ver POD',
  searchARTs: 'Pesquisar ARTs...',
  noARTsFound: 'Nenhum ART encontrado. Crie seu primeiro ART clicando no botão "Criar Novo ART".',
  createNewART: 'Criar Novo ART',
  selectGig: 'Selecionar Trabalho',
  artName: 'Nome ART',
  artDescription: 'Descrição ART',
  createART: 'Criar ART',
  confirmDeletion: 'Confirmar Exclusão',
  confirmARTDeletion: 'Tem certeza de que deseja excluir o ART',
  primaryLanguage: 'Idioma Primário',
  selectSkills: 'Selecionar Habilidades',
  timeZone: 'Fuso Horário',
  updateART: 'Atualizar ART',
  somethingWentWrong: 'Algo deu errado',
  reloadPage: 'Recarregar Página',
  privatePods: 'PODs Privados',
  activePods: 'PODs Ativos',
  completedPods: 'PODs Concluídos',
  pendingPods: 'PODs Pendentes',
  loadingPods: 'Carregando PODs...',
  retry: 'Tentar Novamente',
  noPodsFound: 'Nenhum POD encontrado',
  createFirstPod: 'Crie seu primeiro POD para começar',
  previous: 'Anterior',
  showing: 'Mostrando',
  size: 'Tamanho',
  teamSize: 'Tamanho da Equipe',
  activeMembers: 'Membros Ativos',
  stakeholders: 'Partes Interessadas',
  podManagers: 'Gerentes POD',
  addManager: 'Adicionar Gerente',
  podManager: 'Gerente POD',
  noManagersAssignedYet: 'Nenhum gerente atribuído ainda',
  addManagersToHelpOversee: 'Adicione gerentes para ajudar a supervisionar este POD',
  noStakeholdersYet: 'Nenhuma parte interessada ainda',
  settings: 'Configurações',
  deletePod: 'Excluir POD',
  addPodManager: 'Adicionar Gerente POD',
  selectManagerToInvite: 'Selecione um gerente para convidar para este POD:',
  noManagersAvailableToInvite: 'Nenhum gerente disponível para convidar.',
  selectAManager: 'Selecionar um gerente',
  selectedManager: 'Gerente Selecionado',
  inviteManager: 'Convidar Gerente',
  noTeamMembersYet: 'Nenhum membro da equipe ainda',
  startByInvitingMembers: 'Comece convidando membros para seu POD',
  inviteTeamMembers: 'Convidar Membros da Equipe',
  existingMembers: 'Membros Existentes',
  inviteByEmail: 'Convidar por E-mail',
  searchByNameOrSkills: 'Pesquisar por nome ou habilidades...',
  optionalSelectUserToNotify: 'Opcional: Selecione um usuário para notificar via Slack',
  pleaseSelectPodToEnableFields: 'Por favor, selecione um POD para habilitar outros campos',
  selectedCandidates: 'Candidatos Selecionados',
  selectCandidatesToInvite: 'Selecione candidatos para convidar para este POD',
  availableCandidates: 'Candidatos Disponíveis',
  inviteNewMembersByEmail: 'Convidar Novos Membros por E-mail',
  emailAddresses: 'Endereços de E-mail',
  enterEmailAddresses: 'Digite endereços de e-mail (separados por vírgulas)',
  hidePodTeamMembers: 'Ocultar membros da equipe deste POD na seção Encontrar PODs (Atualmente Visível)',
  technicalDetails: 'Detalhes Técnicos',
  currentTeamSize: 'Tamanho atual da equipe',
  communicationDetails: 'Detalhes de Comunicação',
  podReview: 'Avaliação POD',
  rating: 'Classificação',
  writeReview: 'Escrever Avaliação',
  shareYourExperience: 'Compartilhe sua experiência com este POD...',
  submitReview: 'Enviar Avaliação',
  viewPod: 'Ver POD',
  managePod: 'Gerenciar POD',
  editPod: 'Editar POD',
  skillsAndExperience: 'Habilidades e Experiência',
  reviews: 'Avaliações',
  documents: 'Documentos',
  otherInfo: 'Outras Informações',
  noWorkExperienceDataAvailable: 'Nenhum dado de experiência profissional disponível',
  selectART: 'Selecionar ART',
  selectAnART: 'Selecionar um ART',
  jiraConfiguration: 'Configuração Jira',
  jiraProjectKey: 'Chave do Projeto Jira',
  jiraURL: 'URL Jira',
  jiraAdminEmail: 'E-mail do Admin Jira',
  jiraAdminAPIToken: 'Token API do Admin Jira',
  jiraOpenStoryBugStatus: 'Status de História/Bug Aberto Jira',
  jiraClosedStoryBugStatus: 'Status de História/Bug Fechado Jira',
  gitHubConfiguration: 'Configuração GitHub',
  gitHubUsername: 'Nome de Usuário GitHub',
  gitHubAPIToken: 'Token API GitHub',
  gitHubRepositoryName: 'Nome do Repositório GitHub',
  circleCIConfiguration: 'Configuração CircleCI',
  circleCIGitHubUsername: 'Nome de Usuário GitHub CircleCI',
  circleCIGitHubRepository: 'Repositório GitHub CircleCI',
  circleCIAPIToken: 'Token API CircleCI',
  sonarQubeConfiguration: 'Configuração SonarQube',
  sonarQubeCloudURL: 'URL SonarQube Cloud',
  sonarQubeAPIToken: 'Token API SonarQube',
  awsConfiguration: 'Configuração AWS',
  awsAccessKeyID: 'ID da Chave de Acesso AWS',
  awsSecretAccessKey: 'Chave de Acesso Secreta AWS',
  awsRegion: 'Região AWS',
  bitBucketConfiguration: 'Configuração BitBucket',
  bitBucketUsername: 'Nome de Usuário BitBucket',
  bitBucketAppPassword: 'Senha do App BitBucket',
  bitBucketWorkspace: 'Workspace BitBucket',
  openAIConfiguration: 'Configuração OpenAI',
  openAIToken: 'Token OpenAI',
  storyPointsCalculation: 'Cálculo de Story Points',
  uploadStoryPointsCalculationFile: 'Enviar Arquivo de Cálculo de Story Points',
  currentFile: 'Arquivo atual',
  notifications: 'Notificações',
  markAllAsRead: 'Marcar todas como lidas',
  tryAgain: 'Tentar Novamente',
  noNotificationsToDisplay: 'Nenhuma notificação para exibir',
  viewAllNotifications: 'Ver Todas as Notificações',
  enterMultipleEmailsSeparatedByCommas: 'Digite múltiplos e-mails separados por vírgulas',
  addEmailAddressesToInvite: 'Adicione endereços de e-mail para convidar novos membros',
  emailInvitationGuidelines: 'Diretrizes de Convite por E-mail',
  inviteesWillReceiveInstructions: 'Convidados receberão instruções para se juntar a este POD',
  theyWillNeedToCreateAccount: 'Eles precisarão criar uma conta se ainda não tiverem uma',
  noCandidatesAvailable: 'Nenhum candidato disponível',
  sendEmailInvites: 'Enviar Convites por E-mail',

  processingDataAndGeneratingInsights: 'Processando dados e gerando insights',
  retroHistory: 'Histórico de Retrospectivas',
  filterByMember: 'Filtrar por Membro',
  podProductivity: 'Produtividade POD',
  totalTasks: 'Total de Tarefas',
  completed: 'Concluído',
  clearFilters: 'Limpar Filtros',
  totalActivities: 'Total de Atividades',
  pendingApproval: 'Aprovação Pendente',
  sortBy: 'Ordenar Por',
  editSolution: 'Editar Solução',
  cannotDeleteAssociatedWithARTs: 'Não é possível excluir - associado com ARTs',
  editART: 'Editar ART',
  createdDate: 'Data de Criação',
  podDetails: 'Detalhes POD',
  currentARTProject: 'ART/Projeto Atual',
  artProject: 'ART/Projeto',
  selectAvailability: 'Selecionar Disponibilidade',
  selectSkill: 'Selecionar Habilidade',
  selectTimezone: 'Selecionar Fuso Horário',
  selectLocation: 'Selecionar Localização',
  selectBudget: 'Selecionar Orçamento',
  podMember: 'Membro POD',
  addToPod: 'Adicionar ao POD',
  talentDetails: 'Detalhes do Talento',
  reviewsFeedback: 'Avaliações e Feedback',
  noEducationDataAvailable: 'Nenhum dado de educação disponível',
  noCertificationDataAvailable: 'Nenhum dado de certificação disponível',
  clientReview: 'Avaliação do Cliente',
  noReviewsAvailableYet: 'Nenhuma avaliação disponível ainda',
  noClientReviews: 'Este talento não recebeu nenhuma avaliação de cliente até agora',
  resumeAvailable: 'Currículo Disponível',
  viewDownloadResume: 'Ver ou baixar o currículo do candidato',
  noResumeAvailable: 'Nenhum Currículo Disponível',
  noResumeUploaded: 'Este talento não enviou um currículo.',
  codingAssessment: 'Avaliação de Programação',
  assessmentAvailable: 'Avaliação Disponível',
  viewAssessmentResults: 'Ver os resultados da avaliação de programação do candidato',
  noAssessmentAvailable: 'Nenhuma Avaliação Disponível',
  noAssessmentCompleted: 'Este talento não completou uma avaliação de programação.',
  partnerCompanyDetails: 'Detalhes da Empresa Parceira',
  companyIntroductionVideo: 'Vídeo de Apresentação da Empresa',
  videoNotSupported: 'Seu navegador não suporta a tag de vídeo.',
  location: 'Localização',
  noPodsMatchingCriteria: 'Nenhum POD encontrado que corresponda aos seus critérios',
  hirePod: 'Contratar POD',
  notificationHistory: 'Histórico de Notificações',
  filter: 'Filtro',
  allNotifications: 'Todas as Notificações',
  markSelected: 'Marcar Selecionados',
  unread: 'Não lido',
  noNotificationsFound: 'Nenhuma notificação encontrada',
  searchNotifications: 'Pesquisar notificações...',
  subscriptionManagement: 'Gestão de Assinaturas',
  choosePlanPrompt: 'Escolha um plano que melhor se adapte às suas necessidades e cresça conforme você escala',
  cancelSubscription: 'Cancelar Assinatura',
  choosePlan: 'Escolher Plano',
  noPlansAvailable: 'Nenhum Plano Disponível',
  noPlansHelpText: 'Por favor, verifique novamente mais tarde ou entre em contato com o suporte para assistência.',
  currentPlanDetails: 'Detalhes do Plano Atual',
  renewalDate: 'Data de Renovação',
  subscriptionId: 'ID da Assinatura',
  paymentMethod: 'Método de Pagamento',
  cardHolder: 'Portador do Cartão',
  expires: 'Expira',
  brand: 'Marca',
  billingHistory: 'Histórico de Cobrança',
  noInvoiceHistory: 'Nenhum histórico de fatura disponível',
  needHelp: 'Precisa de Ajuda?',
  supportText: 'Se você tiver alguma dúvida sobre nossos planos de assinatura ou precisar de assistência, nossa equipe de suporte está aqui para ajudar.',
  contactSupport: 'Contatar Suporte',
  completeSubscription: 'Complete sua Assinatura',
  planDetails: 'Detalhes do Plano',
  planName: 'Nome do Plano',
  basePrice: 'Preço Base',
  numberOfUsers: 'Número de Usuários',
  billingCycle: 'Ciclo de Cobrança',
  orderSummary: 'Resumo do Pedido',
  annualDiscount: 'Desconto Anual',
  billingPeriod: 'Período de Cobrança',
  tax: 'Imposto',
  totalWithTax: 'Total com Impostos',
  annually: 'anualmente',
  continue: 'Continuar',
  subscriptionSuccessful: 'Assinatura Bem-sucedida!',
  thankYouSubscribing: 'Obrigado por assinar',
  subscriptionActivated: 'Sua assinatura foi ativada com sucesso.',
  goToDashboard: 'Ir para o Painel',
  addPaymentMethod: 'Adicionar Método de Pagamento',
  cardNumber: 'Número do Cartão',
  cardholderName: 'Nome do Portador do Cartão',
  expiryMonth: 'Mês de Expiração',
  expiryYear: 'Ano de Expiração',
  postalCode: 'Código Postal',
  addCard: 'Adicionar Cartão',
  paymentChoice: 'Use o Cartão Existente ou Adicione um Novo Cartão',
  existingCardText: 'Você já tem um cartão existente terminando em',
  useExistingCardPrompt: 'Gostaria de usá-lo para esta assinatura?',
  useExistingCard: 'Usar Cartão Existente',
  addNewCard: 'Adicionar Novo Cartão',
  processing: 'Processando...',
  subscriptionSuccessDetails: 'foi bem-sucedida!',
  accessAllFeatures: 'Agora você pode acessar todos os recursos incluídos no seu plano de assinatura.',
  editCardDetails: 'Editar Detalhes do Cartão',
  managerInvite: 'Convite de Gerente',
  talentInvite: 'Convite de Talento',
  invitePodManagers: 'Digite o E-Mail para Convidar Gerentes de Pod',
  enterEmail: 'Digite o E-Mail',
  invite: 'Convidar',
  yourInvoices: 'Suas Faturas',
  getCountIsseswithNoCritria: 'Obter contagem de problemas sem critérios de aceitação',
  noInvoices: 'Você não tem nenhuma fatura.',
  amountDue: 'Valor Devido',
  amountPaid: 'Valor Pago',
  noActiveSubscription: 'Você não tem um plano de assinatura ativo. Por favor, clique no link "Assinar" para adicionar uma assinatura.',
   noActiveSubscriptionStart: 'Você não tem um plano de assinatura ativo. Por favor, clique no',
  subscribe: 'Assinar',
  noActiveSubscriptionEnd: 'link para adicionar uma assinatura.'
};
export default messagesPt;